import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios';

const { REACT_APP_BACKEND_URL } = process.env;

export default function getApiClient(
    type: 'admin' | 'user' | undefined = 'user'
): AxiosInstance {
    const headers: AxiosRequestHeaders = {};

    let token: string | null = null;
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            token = window.localStorage.getItem(`${type}Token`);
        }
    } catch (e) {
        token = null;
    }

    if (token) headers.Authorization = `Bearer ${token}`;

    const instance = axios.create({
        baseURL: REACT_APP_BACKEND_URL || '/api/v1/',
        responseType: 'json',
        headers,
    });
    instance.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.response && error.response.status === 401) {
                try {
                    if (typeof window !== 'undefined' && window.localStorage) {
                        window.localStorage.removeItem(`${type}Token`);
                    }
                } catch (e) {
                    // ignore
                }
            }
            return Promise.reject(error);
        }
    );
    return instance;
}
